import { mergeListingFilters } from './merge-listing-filters.util';
import { parseListingGetUrl } from './parse-listing-get-url.util';
import type { ParsedListingFilters, SeoResolveData } from '../types';

/**
 * Builds selected filter state for a permalink page from seo/resolve listingGetUrl
 * (permalink identity) merged with pass-through query params on the address bar.
 */
export const buildPermalinkListingFilters = (
  resolved: SeoResolveData | null,
  permalink: string,
): ParsedListingFilters | null => {
  if (!resolved) {
    return null;
  }

  return mergeListingFilters(
    parseListingGetUrl(resolved.listingGetUrl),
    parseListingGetUrl(permalink),
  );
};
